import React from "react";

import {
  Marker,
} from "react-simple-maps";

const AirportMarker = (props) => {
  const {name, coordinates} = props;
  if (!name || !coordinates || !Array.isArray(coordinates) || coordinates.length < 2) return null;
  return (
    <Marker key={name} coordinates={coordinates}>
      <g
        fill="#303030"
        stroke="#000000"
        transform="translate(-4, -15) matrix(0.35,0,0,0.35,0,0)"
      >
        <path d="M3.005,2.673L2.855,2.673C2.774,2.673 2.708,2.607 2.708,2.526L2.708,2.232C2.708,2.15 2.774,2.084 2.855,2.084L8.579,2.084C8.741,1.469 9.597,1.011 10.621,1.011C11.646,1.011 12.501,1.469 12.663,2.084L18.387,2.084C18.468,2.084 18.534,2.15 18.534,2.232L18.534,2.526C18.534,2.607 18.468,2.673 18.387,2.673L18.237,2.673L17.242,9.235L17.003,9.235L17.003,10.117L20.912,10.117C21.004,10.117 21.079,10.192 21.079,10.284L21.079,10.619C21.079,10.711 21.004,10.786 20.912,10.786L20.833,10.786L19.251,18.166L19.299,18.166C19.392,18.166 19.466,18.241 19.466,18.333L19.466,18.668C19.466,18.76 19.392,18.835 19.299,18.835L14.677,18.835L14.677,40.62L6.565,40.62L6.565,18.835L1.943,18.835C1.851,18.835 1.776,18.76 1.776,18.668L1.776,18.333C1.776,18.241 1.851,18.166 1.943,18.166L1.98,18.166L0.409,10.786L0.33,10.786C0.238,10.786 0.163,10.711 0.163,10.619L0.163,10.284C0.163,10.192 0.238,10.117 0.33,10.117L4.239,10.117L4.239,9.235L4,9.235L3.005,2.673ZM16.239,9.235L15.003,9.235L15.003,10.117L16.239,10.117L16.239,9.235ZM14.239,9.235L13.003,9.235L13.003,10.117L14.239,10.117L14.239,9.235ZM12.239,9.235L11.003,9.235L11.003,10.117L12.239,10.117L12.239,9.235ZM10.239,9.235L9.003,9.235L9.003,10.117L10.239,10.117L10.239,9.235ZM8.239,9.235L7.003,9.235L7.003,10.117L8.239,10.117L8.239,9.235ZM6.239,9.235L5.003,9.235L5.003,10.117L6.239,10.117L6.239,9.235ZM6.084,6.002L4.268,6.002L4.624,8.252L6.266,8.252L6.084,6.002ZM10.395,6.002L8.796,6.002L8.851,8.252L10.395,8.252L10.395,6.002ZM12.528,6.002L12.466,8.252L10.844,8.243L10.844,6.002L12.528,6.002ZM14.637,6.002L14.449,8.252L13.015,8.243L13.069,6.002L14.637,6.002ZM8.218,6.002L6.638,6.002L6.824,8.252L8.266,8.252L8.218,6.002ZM17.012,6.002L16.657,8.243L15.015,8.243L15.199,6.002L17.012,6.002ZM6.038,5.432L5.847,3.068L3.803,3.068L4.177,5.432L6.038,5.432ZM8.206,5.432L8.155,3.068L6.395,3.068L6.591,5.432L8.206,5.432ZM8.782,5.432L10.395,5.432L10.395,3.068L8.724,3.059L8.782,5.432ZM10.844,5.432L10.844,3.059L12.609,3.068L12.544,5.432L10.844,5.432ZM13.082,5.432L13.139,3.059L14.881,3.068L14.684,5.432L13.082,5.432ZM17.103,5.432L15.246,5.432L15.441,3.059L17.479,3.059L17.103,5.432Z"/>
      </g>
      <text
        textAnchor="middle"
        x={0}
        y={8}
        style={{ 
          fontSize: props.fontSize||10, 
          fontFamily: "system-ui", 
          fill: "#000000", 
          stroke:"#eeeeee", 
          paintOrder: "stroke",
          strokeWidth: "1px",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
        }}
      >
        {name}
      </text>
    </Marker>
  )
}
export default AirportMarker;